/* ==========================================================================
   VARENZO — navigation helpers
   1. In-page section links (VARENZO Standard, Men/Women shop) work from ANY
      page: on the homepage they scroll to the section; elsewhere they go to
      the homepage and land on that section.
   2. "Back to collection" on a product page returns the shopper to the exact
      spot they left on the homepage grid.
   3. Visitors arriving from Google ("Read more") see the page from the top,
      not jumped down to highlighted text.
   4. Footer "Cookie Preferences" reopens the cookie settings panel.
   Horizon scrolls inside .page-wrapper on desktop and on window on mobile,
   so every scroll here goes through the element that actually scrolls.
   ========================================================================== */
(function () {
  "use strict";

  var RETURN_KEY = "varenzo-return-v1";
  var RESTORE_KEY = "varenzo-restore-v1";
  var CONSENT_KEY = "varenzo-consent-v1";
  var MAX_AGE = 2 * 60 * 60 * 1000;

  function store(action, key, value) {
    try {
      if (action === "get") return sessionStorage.getItem(key);
      if (action === "set") sessionStorage.setItem(key, value);
      if (action === "del") sessionStorage.removeItem(key);
    } catch (e) { /* storage unavailable */ }
    return null;
  }

  function readReturn() {
    try { return JSON.parse(store("get", RETURN_KEY) || "null"); } catch (e) { return null; }
  }

  function wrapper() { return document.querySelector(".page-wrapper"); }

  function activeScroller() {
    var w = wrapper();
    if (w) {
      var oy = window.getComputedStyle(w).overflowY;
      if ((oy === "auto" || oy === "scroll") && w.scrollHeight > w.clientHeight + 1) return w;
    }
    return null;
  }

  function currentY() {
    var w = wrapper();
    var wy = w ? w.scrollTop : 0;
    var y = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
    return Math.max(wy, y);
  }

  function scrollToY(y, smooth) {
    var opts = { top: Math.max(0, y), behavior: smooth ? "smooth" : "auto" };
    var s = activeScroller();
    if (s) s.scrollTo(opts);
    else window.scrollTo(opts);
  }

  function scrollAllToTop() {
    var w = wrapper();
    if (w) w.scrollTop = 0;
    window.scrollTo(0, 0);
  }

  function headerOffset() {
    var h = document.getElementById("v-header");
    if (!h) return 0;
    var pos = window.getComputedStyle(h).position;
    return pos === "fixed" || pos === "sticky" ? h.getBoundingClientRect().height : 0;
  }

  function scrollToElement(el, smooth) {
    var y = el.getBoundingClientRect().top + currentY() - headerOffset() - 8;
    scrollToY(y, smooth);
  }

  function hashTarget(hash) {
    if (!hash || hash.length < 2 || hash.indexOf(":~:") !== -1) return null;
    try { return document.getElementById(decodeURIComponent(hash.slice(1))); } catch (e) { return null; }
  }

  function currentPath() { return location.pathname + location.search; }
  function isProductPage() { return location.pathname.indexOf("/products/") !== -1; }
  function toUrl(href) { try { return new URL(href, location.href); } catch (e) { return null; } }

  function cameFromSearch() {
    if (!document.referrer) return false;
    var r = toUrl(document.referrer);
    return !!r && r.origin !== location.origin && /(^|\.)(google|bing|yahoo|duckduckgo)\./i.test(r.hostname);
  }

  function openCookiePreferences() {
    var banner = document.getElementById("v-cookie-consent");
    if (!banner) return false;
    var saved = null;
    try { saved = JSON.parse(localStorage.getItem(CONSENT_KEY) || "null"); } catch (e) { saved = null; }
    var analytics = document.getElementById("v-cookie-analytics");
    var marketing = document.getElementById("v-cookie-marketing");
    if (saved) {
      if (analytics) analytics.checked = !!saved.analytics;
      if (marketing) marketing.checked = !!saved.marketing;
    }
    var prefs = document.getElementById("v-cookie-prefs");
    var customize = document.getElementById("v-cookie-customize");
    if (prefs) prefs.classList.add("open");
    if (customize) customize.setAttribute("aria-expanded", "true");
    banner.classList.add("is-visible");
    banner.setAttribute("aria-hidden", "false");
    return true;
  }

  var userScrolled = false;
  function markUserScroll() { userScrolled = true; }
  window.addEventListener("wheel", markUserScroll, { passive: true });
  window.addEventListener("touchstart", markUserScroll, { passive: true });
  window.addEventListener("keydown", markUserScroll);

  /* 1. Remember where the shopper was before opening a product. */
  document.addEventListener("click", function (e) {
    if (isProductPage() || !e.target.closest) return;
    var a = e.target.closest("a[href]");
    if (!a) return;
    var url = toUrl(a.getAttribute("href"));
    if (!url || url.origin !== location.origin || url.pathname.indexOf("/products/") === -1) return;
    store("set", RETURN_KEY, JSON.stringify({ url: currentPath(), y: currentY(), t: Date.now() }));
  }, true);

  /* 2. Cookie preferences, section links + smart back link. */
  document.addEventListener("click", function (e) {
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0 || !e.target.closest) return;

    if (e.target.closest("[data-v-cookie-prefs]")) {
      if (openCookiePreferences()) e.preventDefault();
      return;
    }

    var back = e.target.closest("[data-v-back]");
    if (back) {
      var saved = readReturn();
      if (!saved || !saved.url || Date.now() - saved.t > MAX_AGE) return; /* fall back to the link's href */
      e.preventDefault();
      store("set", RESTORE_KEY, String(Date.now()));
      var ref = document.referrer ? toUrl(document.referrer) : null;
      if (ref && ref.origin === location.origin && ref.pathname + ref.search === saved.url && history.length > 1) {
        history.back();
      } else {
        location.href = saved.url;
      }
      return;
    }

    var a = e.target.closest("a[href*='#']");
    if (!a) return;
    var url = toUrl(a.getAttribute("href"));
    if (!url || url.origin !== location.origin || url.pathname !== location.pathname) return;
    var el = hashTarget(url.hash);
    if (!el) return;
    e.preventDefault();
    scrollToElement(el, true);
    if (history.replaceState) history.replaceState(null, "", url.pathname + url.search + url.hash);
  });

  /* 3. On arrival: restore the saved spot, land on a linked section, or
        (from Google) stay at the top of the page. */
  function afterLoad(fn) {
    if (document.readyState === "complete") setTimeout(fn, 60);
    else window.addEventListener("load", function () { setTimeout(fn, 60); });
  }

  function restoreIfRequested() {
    var flag = store("get", RESTORE_KEY);
    if (!flag) return false;
    store("del", RESTORE_KEY);
    var saved = readReturn();
    if (!saved || saved.url !== currentPath() || Date.now() - Number(flag) > 30000) return false;
    if ("scrollRestoration" in history) history.scrollRestoration = "manual";
    scrollToY(saved.y, false);
    afterLoad(function () {
      if (!userScrolled && Math.abs(currentY() - saved.y) > 40) scrollToY(saved.y, false);
    });
    return true;
  }

  function scrollToHashOnArrival(el) {
    scrollToElement(el, false);
    afterLoad(function () { if (!userScrolled) scrollToElement(el, false); });
  }

  function stayAtTop() {
    if ("scrollRestoration" in history) history.scrollRestoration = "manual";
    [0, 150, 450, 900, 1500].forEach(function (ms) {
      setTimeout(function () { if (!userScrolled) scrollAllToTop(); }, ms);
    });
    afterLoad(function () { if (!userScrolled) scrollAllToTop(); });
  }

  function init() {
    if (restoreIfRequested()) return;
    var el = hashTarget(location.hash);
    if (el) { scrollToHashOnArrival(el); return; }
    if (cameFromSearch()) stayAtTop();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();

  /* Page restored from the back/forward cache already has the right position. */
  window.addEventListener("pageshow", function (e) {
    if (e.persisted) store("del", RESTORE_KEY);
  });
})();
